export default "/images/vendor/flag-icon-css/flags/1x1/tm.svg?61ac9a09d717c6899190b1563a624593";